// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { CommonStyles, CommonSuperAppStyles } from "@msnews/social-utils";
import { ReactionMenuStyles } from "./common/reaction-menu/ReactionMenu.styles";
import { SocialBarPanelStyles } from "./common/social-bar-panel/SocialBarPanel.styles";
import { ContentSocialBarStyles } from "./content-social-bar/ContentSocialBar.styles";
import { ContentSocialBarSuperAppStyles } from "./content-social-bar/themes/superapp/ContentSocialBarSuperApp.styles";
import { SocialBarClassNameContract } from "./SocialBar.classnames";

/**
 * The Social styles
 * @type {ComponentStyles<SocialClassNameContract, DesignSystem>}
 */
export const SocialBarStyles: ComponentStyles < SocialBarClassNameContract, DesignSystem > = (config: DesignSystem) => ({
    ...CommonStyles(config),
    ...ReactionMenuStyles(config),
    ...ContentSocialBarStyles(config),

    /** SuperApp Styles */
    ...CommonSuperAppStyles(config),
    ...ContentSocialBarSuperAppStyles(config),
    ...SocialBarPanelStyles(config)
});